import Cookies from 'js-cookie';

export const Helpers = (() => {
	'use strict';

	function init() {
		links();
		mobile_menu();
		body_scroll();
		check();
		cookieBanner();
		cookieCheck();
		animate();
		headerMargin();
		pageOrbs();
	}

	

	function links() {
		document.querySelectorAll('a').forEach((anchorTag) => {
			// External links
			if (
				anchorTag.href.indexOf(window.location.host) < 0 &&
				anchorTag.href.indexOf('mailto') < 0 &&
				anchorTag.href.indexOf('tel') < 0
			)
				anchorTag.setAttribute('target', '_blank');

			// Anchor links
			if (anchorTag.href.indexOf('#') === 0 && !document.getElementById(anchorTag.href.replace('#', '')))
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
		});
	}

	function mobile_menu() {

		var mobileTrigger = document.querySelector('.site-header__mobile-trigger');

		if (!mobileTrigger);

		$(mobileTrigger).on('click', function (e) {
			mobileTrigger.classList.toggle('open');
			document.body.classList.toggle('mobile-nav-open');
		})

		$(".menu-item-has-children").append("<span class='open-sub-menu'></span>");

		$('.open-sub-menu').on('click', function (e) {
			$(this).siblings('a').toggleClass('active');
			$(this).siblings('.sub-menu').toggleClass('sub-menu--open');
			$(this).parents('li').siblings('li:not(menu-item-has-children)').slideToggle();
			$('.open-sub-menu').toggleClass('open-sub-menu--active')
		})
	}

	function headerMargin() {
		var $header = $('.site-header');
		var headerHeight = $header.outerHeight();
		console.log(headerHeight);
		$('main').css('margin-top', headerHeight);
	}

	function body_scroll() {

		window.addEventListener('scroll', () => {
			window.scrollY > 1 ? document.body.classList.add('scrolled') : document.body.classList.remove('scrolled');

		}, 1);

	}

	function check() {
		if ($('.pxblock:first').hasClass('pxblock--text')) {
			$('.pxblock:first').addClass('pxblock--top');
		};
		/*The reason this is setup for bg--white, there is a last block with lilac, not needing this*/
		if ($('.pxblock:last').hasClass('bg--white')) {
			$('.pxblock:last').addClass('pxblock--bottom');
		} else {
			$('.pxblock:last').addClass('pxblock--none');
		}
	}

	function cookieCheck() {
		var cookieAccepted = Cookies.get('acceptedCookiePrompt');

		console.log('check cookies', cookieAccepted);

		if (cookieAccepted) {

			$('.cookie-banner').hide();

		}
	}

	function cookieBanner() {
		$('.yes').click(function () {

			Cookies.set('acceptedCookiePrompt', 'yes');

			cookieCheck();

		})

		$('.no').click(function () {

			Cookies.set('acceptedCookiePrompt', 'no');
			cookieCheck();

		})


	}

	let $win, $winH, $animateIn, threshold, distScrolled;

	function animate() {
		$win = $(window);
		$animateIn = $('.animate-in');
		distScrolled = 0;



		// if ($animateIn.length) {
		resize();
		checkElements();
		$win.on('scroll', checkElements);
		$win.on('resize', resize);
		// }
	}

	function resize() {

		$winH = $(window).height();
		threshold = $winH * 0.15; // this controls when the animation occurs - distance from bottom of window
	}

	function checkElements() {
		distScrolled = $win.scrollTop();

		$animateIn.each(function (i, el) {
			let $el = $(el);
			let elTreshold = $el.data('threshold') ? $(window).height() * ($el.data('threshold') / 100) : threshold;
			let elDist = $el.offset().top - ($winH - elTreshold);



			if (distScrolled > elDist) {
				$el.addClass('animated');
				$animateIn = $('.animate-in:not(.animated)');

			}
		});

		$('.hr--orange').each(function () {

			let $el = $(this);
			let elTreshold = $el.data('threshold') ? $(window).height() * ($el.data('threshold') / 100) : threshold;
			let elDist = $el.offset().top - ($winH - elTreshold);



			if (distScrolled > elDist) {
				$el.addClass('animated');


			}

		})


	}

	function pageOrbs() {
		if ($('#pxMainContent').hasClass('page-orbs')) {
			$('#pxMainContent').append($('<div class="orbs-container"></div>'));
			
			$('.orbs-container').append($('<div class="orbs orbs--large"></div>'));
			$('.orbs-container').append($('<div class="orbs orbs--medium"></div>'));
			$('.orbs-container').append($('<div class="orbs orbs--small"></div>'));
		}
	}

	return {
		init: init,
	};
})();
